import type OlMap from "ol/Map"

export enum OpenLayersLayer {
  BASE = "base",
  PICKER = "picker",
  MARKER = "marker",
  MARKER_CLUSTER = "marker_cluster",
  MARKER_CLUSTER_CONVEX_HULL = "marker_cluster_convex_hull",
  SATELLITE = "Actueel_orthoHR",
  PDOK = "pdok",
  DUOPP = "duopp",
  GIS = "gis",
  RELATION = "relation",
  POSITION = "position",
}

export const useLayerManagement = (map: Ref<OlMap | null>) => {
  const getLayer = (layerName: string) => {
    if (!map.value) return

    return map.value
      .getLayers()
      .getArray()
      .find((layer) => layer.get("name") === layerName)
  }

  const getAllLayers = () => {
    if (!map.value) return

    return map.value.getLayers().getArray()
  }

  const removeLayer = (layerName: string) => {
    if (!map.value) return

    const layer = getLayer(layerName)
    if (layer) {
      map.value.removeLayer(layer)
      return true
    }

    return false
  }

  return {
    getLayer,
    removeLayer,
    getAllLayers,
  }
}
